module.exports = __webpack_public_path__ + "static/media/CenturyGothic.9064ea3d.woff2";